import { render, staticRenderFns } from "./BulkItemCreate.vue?vue&type=template&id=f5092cee&scoped=true&"
import script from "./BulkItemCreate.vue?vue&type=script&lang=js&"
export * from "./BulkItemCreate.vue?vue&type=script&lang=js&"
import style0 from "./BulkItemCreate.vue?vue&type=style&index=0&id=f5092cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5092cee",
  null
  
)

export default component.exports